import { ReactNode } from 'react';
import { Col, Row } from 'reactstrap';
import { ConditionalFragment } from 'react-conditionalfragment';
import { Banner } from '../shared/Banner';
import { PillsNavBar } from '../shared/pillsNavBar/PillsNavBar';
import { HelpNavigation } from './HelpNavigation';
import { useIsCampaignAdmin } from './useIsCampaignAdmin';

export interface HelpBannerProps {
    title?: string,
    subTitle?: string,
    /**
     * Larger header to show in place of the title and sub title. The banner grows to fit it.
     */
    hero?: ReactNode,
}

/**
 * Banner shared by the help pages. Users who run campaigns get navigation between the help pages above the title. Users
 * who only answer questionnaires only have the FAQs, so they get no navigation.
 */
export const HelpBanner = (props: HelpBannerProps) => {
    const { title, subTitle, hero } = props;
    const isCampaignAdmin = useIsCampaignAdmin();

    return (
        <Banner fluid className={hero ? 'help-banner-hero' : undefined}>
            <ConditionalFragment showIf={!!isCampaignAdmin}>
                <Row>
                    <Col xs={12}>
                        <PillsNavBar>
                            <HelpNavigation />
                        </PillsNavBar>
                    </Col>
                </Row>
            </ConditionalFragment>
            {
                hero ? hero
                    : (
                        <Row className={isCampaignAdmin ? 'bannerWithPills' : 'bannerNoPills'}>
                            <Col xs={12}>
                                <h1>{title}</h1>
                            </Col>
                            <Col xs={12}>
                                <h2 className="sub-title">{subTitle}</h2>
                            </Col>
                        </Row>
                    )
            }
        </Banner>
    );
};
